import React from "react";
import "./About.css";
import ME from "../../src/asserts/about-me.jpg";
import { FaAward } from "react-icons/fa";
import {DiAptana} from 'react-icons/di'
import { VscFolderLibrary } from "react-icons/vsc";


const About = () => {
  return (
    <section id="about">
      <h5>Get to know</h5>
      <h2>About me</h2>
      <div className="container about-container">
        <div className="about-me">
          <img src={ME} alt="About me" />
        </div>
        <div className="about-content">
          <div className="about-cards">
            <article className="about-card">
              <FaAward className="about-icon" />
              <h5>Experience</h5>
              <small>1+ Years Working</small>
            </article>
            
            <article className="about-card">
              <VscFolderLibrary className="about-icon" />
              <h5>Projects</h5>
              <small>10+ Completed</small>
            </article>
          </div>
          <div class="about-me-details">
           
            <span class="about-me-description">Full stack web with background knowledge of MERN stacks with redux,
             along with a knack of building applications with utmost efficiency.</span>
             <div class="about-me-highlights"><div class="highlight-heading">
               <span>Here are a Few Highlights:</span></div><div class="highlight">
                 <div class="highlight-blob"></div><span>Full Stack web  development</span>
                 </div><div class="highlight"><div class="highlight-blob"></div><span>Interactive Front End as per the design</span>
                 </div><div class="highlight"><div class="highlight-blob"></div><span>React and React js</span></div>
                 <div class="highlight"><div class="highlight-blob"></div><span>Redux for State Mnanagement</span>
                 </div><div class="highlight"><div class="highlight-blob"></div><span>Building REST API</span></div>
                 <div class="highlight"><div class="highlight-blob"></div><span>Managing database</span></div></div>
                 </div>
            
          <a href="#contact" className="btn btn-primary">
            Let's Talk
          </a>
        </div>
      </div>
  
    </section>
     
  );
};

export default About;